module.exports = "/Frontend/logo.c70af002637586865f139cd1dd666c72.svg";